import { useState } from 'react';
import { FlexContainer } from '@facephi/ui-react';
import { ListOperationHeader } from './ListOperationHeader';
import { ListOperationTable } from './ListOperationTable';

export const ListOperation = () => {
  const [filters, setFilters] = useState({});

  return (
    <FlexContainer flexDirection="column" rowGap="2.4" flex="1">
      <ListOperationHeader onChangeFilter={setFilters} />
      <ListOperationTable filters={filters} />
    </FlexContainer>
  );
};
